import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MaintenancePage from './components/MaintenancePage';
import reportWebVitals from './reportWebVitals';


import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

// Cognito設定をマージ（amplify pushによるaws-exports.js上書き対策）
const cognitoConfig = {
  aws_project_region: 'ap-northeast-1',
  aws_cognito_identity_pool_id: 'ap-northeast-1:5d1a671d-b628-4d3d-8cfb-a3af0abe11d6',
  aws_cognito_region: 'ap-northeast-1',
  aws_user_pools_id: 'ap-northeast-1_qfvSp29vn',
  aws_user_pools_web_client_id: '5ld5qvv4jrgvqnp7mf7si9gnqp',
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: ['TOTP'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: []
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
};

// Amplify の既定ドメインで開かれた場合は正式ドメインへ転送する
// （パスキーは factime.jp に関連付けているため、他のドメインではログインできない）
const LEGACY_HOSTS = ['main.d2031ls8g0b88h.amplifyapp.com'];
if (LEGACY_HOSTS.includes(window.location.hostname)) {
  const { pathname, search, hash } = window.location;
  window.location.replace(`https://factime.jp${pathname}${search}${hash}`);
}

// メンテナンスモード（Amplify Hosting の環境変数 REACT_APP_MAINTENANCE_MODE=true でビルドすると有効）
const isMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

Amplify.configure({ ...cognitoConfig, ...awsExports });

const root = ReactDOM.createRoot(document.getElementById('root'));
// メンテナンス中は App（認証・API呼び出しを含む）を一切描画しない
root.render(
  isMaintenance ? <MaintenancePage /> : <App />
);

reportWebVitals();
